import { getPercentileColor } from "../../../utils/colorUtils";

export const Bar = ({ percentile }) => {
  const width = percentile ? Math.min(percentile, 100) : 0;
  const color = percentile ? getPercentileColor(percentile) : "#d1d5db";
  return (
    <div className="relative w-full h-3 bg-gray-200 rounded">
      <div
        className="absolute left-0 top-0 h-3 rounded transition-all duration-500 ease-out"
        style={{ width: `${width}%`, backgroundColor: color }}
      />
    </div>
  );
};

export const StatRow = (props) => {
  const { label, value, percentile, rank, totalCount, decimals = 1, suffix = "", isQualified = true } = props;
  const displayValue = value != null ? Number(value).toFixed(decimals) : "-";
  const percentileText = percentile != null ? `${percentile}th percentile` : "-";
  const rankingText = rank && totalCount ? `#${rank} of ${totalCount}` : "-";

  const textColor = isQualified ? "text-gray-700" : "text-gray-400";
  const valueColor = isQualified ? "text-gray-900" : "text-gray-400";
  const subtitleColor = isQualified ? "text-gray-500" : "text-gray-400";

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex justify-between items-baseline text-sm">
        <span className={`font-medium ${textColor}`}>{label}</span>
        <span className={`font-mono text-sm ${valueColor}`}>
          {displayValue}{suffix}
        </span>
      </div>
      <Bar percentile={isQualified ? percentile : null} />
      <div className="flex justify-between items-center text-xs">
        <span className={subtitleColor}>
          {isQualified ? percentileText : "Not qualified"}
        </span>
        <span className={`font-mono ${subtitleColor}`}>
          {isQualified ? rankingText : "N/A"}
        </span>
      </div>
    </div>
  );
};

export const Category = (props) => {
  const { title, stats, isQualified = true } = props;
  return (
  <div className="flex flex-col gap-3 border border-gray-200 rounded-xl p-3 bg-white shadow-sm">
    <h3 className="text-xs font-semibold text-gray-600 tracking-wide uppercase">{title}</h3>
    <div className="flex flex-col gap-3">
      {stats.map((stat) => (
        <StatRow key={stat.label} {...stat} isQualified={isQualified} />
      ))}
    </div>
  </div>
  );
};
